import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const FormTemplateAPI = {
    getAllFormTemplate: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/form-template/${clubId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllApprovedFormTemplate: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/form-template/approved/${clubId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllFormFieldsWithSection: async function (clubId,templateId) {
        const response = await axiosInstance.request({
            url: `/form-template/form-fields/${clubId}/${templateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllFormFieldsWithSectionByEvent: async function (clubId, eventId) {
        const response = await axiosInstance.request({
            url: `/form-template/form-fields/${clubId}/event/${eventId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getFormTemplateName: async function (templateId) {
        const response = await axiosInstance.request({
            url: `/form-template/info/${templateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllFormSection: async function (clubId, templateId) {
        const response = await axiosInstance.request({
            url: `/form-template/form-sections/${clubId}/${templateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllParticipantFee: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/participant-fee/${clubId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllSelectedParticipantFee: async function (formTemplateId) {
        const response = await axiosInstance.request({
            url: `/participant-fee/selected/${formTemplateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllPaymentMethod: async function () {
        const response = await axiosInstance.request({
            url: `/payment-method/`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllAttachedPaymentMethod: async function (formTemplateId) {
        const response = await axiosInstance.request({
            url: `/payment-method/${formTemplateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllWaiver: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/waiver/${clubId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllAttachedWaiver: async function (formTemplateId) {
        const response = await axiosInstance.request({
            url: `/waiver/attached/${formTemplateId}`,
            method: "GET",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    downloadFormTemplate: async function (clubId, templateId) {
        const response = await axiosInstance.request({
            url: `/form-template/download/${clubId}/${templateId}`,
            method: "GET",
            withCredentials: true,
            responseType:'blob',
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postCreateFormTemplate: async function (formTemplateData) {
        const response = await axiosInstance.request({
            url: `/form-template/create`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: formTemplateData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postDuplicateFormTemplate: async function (formTemplateData) {
        const response = await axiosInstance.request({
            url: `/form-template/copy`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: formTemplateData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddFormField: async function (formFieldData) {
        const response = await axiosInstance.request({
            url: `/form-template/add-field`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: formFieldData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddFormSection: async function (formSectionData) {
        const response = await axiosInstance.request({
            url: `/form-template/add-section`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: formSectionData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddParticipantFee: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/participant-fee/add`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAttachPaymentMethod: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/payment-method/attach`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postCreateWaiver: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/waiver/create`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddWaiverInFormTemplate: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/waiver/add-to-template`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postAddParticipantFeeIntoFormTemplate: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/participant-fee/add-into-form`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    postFormTemplateApproveOrReject: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/form-template/action`,
            method: "POST",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormSection: async function (formSectionData) {
        const response = await axiosInstance.request({
            url: `/form-template/section`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: formSectionData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormFieldIndex: async function (formFieldData) {
        const response = await axiosInstance.request({
            url: `/form-template/form-fields-index`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: formFieldData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormSectionOrderIndex: async function (formFieldData) {
        const response = await axiosInstance.request({
            url: `/form-template/form-section-index`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: formFieldData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormTemplateName: async function (reqData) {
        
        const response = await axiosInstance.request({
            url: `/form-template/name`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormFieldIsShow: async function (formFieldData) {
        const response = await axiosInstance.request({
            url: `/form-template/form-field-is-show`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: formFieldData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateFormField: async function (formFieldData) {
        const response = await axiosInstance.request({
            url: `/form-template/form-field`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: formFieldData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateParticipantFee: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/participant-fee/update`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateWaiver: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/waiver/update`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putSendFormTemplateForApprove: async function (formTemplateId) {
        const response = await axiosInstance.request({
            url: `/form-template/submit/${formTemplateId}`,
            method: "PUT",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    deleteFormField: async function (clubId,formFieldId) {
        const response = await axiosInstance.request({
            url: `/form-template/delete-form-field/${clubId}/${formFieldId}`,
            method: "DELETE",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    deleteFormSection: async function (reqObj) {
        const response = await axiosInstance.request({
            url: `/form-template/delete-section`,
            method: "DELETE",
            withCredentials: true,
            timeout: 10000,
            data:reqObj,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    deleteParticipantFee: async function (reqObj) {
        const response = await axiosInstance.request({
            url: `/participant-fee/remove`,
            method: "DELETE",
            withCredentials: true,
            timeout: 10000,
            data: reqObj,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    deleteWaiver: async function (reqObj) {
        const response = await axiosInstance.request({
            url: `/waiver/remove`,
            method: "DELETE",
            withCredentials: true,
            timeout: 10000,
            data: reqObj,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    deleteInProgressFormTemplate: async function (clubId,formTemplateId) {
        const response = await axiosInstance.request({
            url: `/form-template/remove/club/${clubId}/form/${formTemplateId}`,
            method: "DELETE",
            withCredentials: true,
            timeout: 10000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
}